import store from '../store'

/**
*  Toast公共方法
*/

export function toast (str, icon) {
  store.dispatch('showToast', true)
  if (icon === 'success') {
    store.dispatch('showSuccess', true)
    store.dispatch('showFail', false)
  } else {
    store.dispatch('showSuccess', false)
    store.dispatch('showFail', true)
  }
  store.dispatch('toastMsg', str)
  setTimeout(() => {
    store.dispatch('showToast', false)
  }, 1500)
}

/**
 * dialog公共方法
 */
let i = 0
export function Alerts (json) {
  (function () {
    let title = json.title || '系统提示'
    let message = json.message || '系统提示'
    let hide = json.hide || false
    let item = {'title': title, 'message': message}
    setTimeout(() => {
      store.dispatch('setAlerts', item)
      if (hide) {
        setTimeout(() => {
          store.dispatch('delAlerts', JSON.stringify(item))
          i--
        }, 3500)
      }
    }, i * 800)
    i++
  })(json, i)
}
